import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  BaseErrorHandlerService,
  ErrorData,
  ErrorStorageService,
} from '@awo-care/shared-core';
import { UserService } from './user.service';
import { versionWebsite } from 'package.json';
import { environment } from '@awo-care/shared-auth';
import { chunkErrorKey, chunkErrorMessage, reloadOnce } from '@awo-care/utils';

@Injectable({ providedIn: 'root' })
export class WebsiteErrorHandlerService extends BaseErrorHandlerService {
  private userService = inject(UserService);
  private errorStorage = inject(ErrorStorageService);
  private document = inject(DOCUMENT);
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  /** Nach einem Deploy fehlende Dateien: einmal neu laden statt Fehler melden (#1205). */
  override async handleError(error: unknown): Promise<void> {
    const win = this.document.defaultView;
    const chunkError = this.isBrowser ? chunkErrorMessage(error) : null;
    if (win && chunkError && reloadOnce(win, chunkErrorKey(chunkError))) {
      return;
    }
    return super.handleError(error);
  }

  getUserId(): string {
    return this.userService.currentUser()?.uid || 'unknown';
  }

  getUserEmail(): string {
    return this.userService.currentUser()?.email || 'unknown';
  }

  getAppVersion(): string {
    return versionWebsite;
  }

  getEnvironment(): string {
    return environment.tier || 'unknown';
  }

  getAppType(): 'customer' | 'employee' | 'website' {
    return 'website';
  }

  protected async processError(
    sendErrorData: ErrorData,
    errorData: GlobalError
  ): Promise<void> {
    switch (errorData.bugReport) {
      case 'auto':
        await this.errorStorage.storeError(sendErrorData);
        break;
      case 'manual':
        this.showErrorSnackbar(errorData);
        break;
      case 'none':
        break;
      default:
        if (this.getEnvironment() === 'PROD') {
          await this.errorStorage.storeError(sendErrorData);
        }
        break;
    }
  }
}
